import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Pagination, EffectFade, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { Link } from "react-router-dom";

function BannerOne() {
  const swiperRef = useRef(null);

  useEffect(() => {
    const animationProperties = () => {
      document.querySelectorAll("[data-ani]").forEach((element) => {
        const animationName = element.getAttribute("data-ani");
        element.classList.add(animationName);
      });

      document.querySelectorAll("[data-ani-delay]").forEach((element) => {
        const delayTime = element.getAttribute("data-ani-delay");
        element.style.animationDelay = delayTime;
      });
    };

    animationProperties();
  }, []);

  const handleSliderNavigation = (direction) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      const swiper = swiperRef.current.swiper;
      direction === "prev" ? swiper.slidePrev() : swiper.slideNext();
    }
  };

  return (
    <div className="th-hero-wrapper hero-1" id="hero">
      <Swiper
        modules={[Navigation, Pagination, EffectFade]}
        effect="fade"
        loop={true}
        speed={1000}
        pagination={{ el: ".swiper-pagination", clickable: true }}
        navigation={{ nextEl: ".slider-next", prevEl: ".slider-prev" }}
        className="th-slider hero-slider-1"
        id="heroSlide1"
      >
        {/* ---------- SLIDE 1: OFFICE PRINTERS ---------- */}
        <SwiperSlide>
          <div className="hero-inner">
            <div
              className="th-hero-bg"
              style={{
                backgroundImage: "url(/assets/img/bg/banner1.jpg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            ></div>
            <div className="container">
              <div className="hero-style1">
                <span
                  className="sub-title style1"
                  data-ani="slideinup"
                  data-ani-delay="0.2s"
                >
                  Smart printing for modern offices
                </span>
                <h1
                  className="hero-title"
                  data-ani="slideinup"
                  data-ani-delay="0.4s"
                >
                  Advanced office printers built for reliable performance
                </h1>
                <p
                  data-ani="slideinup"
                  data-ani-delay="0.5s"
                  style={{ maxWidth: "550px", color: "white" }}
                >
                  Improve workflow productivity with high-speed printing,
                  wireless connectivity, and superior document handling — ideal
                  for business use and growing teams.
                </p>
                <div
                  className="btn-group"
                  data-ani="slideinup"
                  data-ani-delay="0.6s"
                >
                  <Link to="/shop" className="th-btn th-icon">
                    Shop Now
                  </Link>
                  <Link to="/contact" className="th-btn style2 th-icon">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>

        {/* ---------- SLIDE 2: HOME PRINTERS ---------- */}
        <SwiperSlide>
          <div className="hero-inner">
            <div
              className="th-hero-bg"
              style={{
                backgroundImage: "url(/assets/img/bg/banner2.jpg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            ></div>
            <div className="container">
              <div className="hero-style1">
                <span
                  className="sub-title style1"
                  data-ani="slideinup"
                  data-ani-delay="0.2s"
                >
                  Smart printing for modern homes
                </span>
                <h1
                  className="hero-title"
                  data-ani="slideinup"
                  data-ani-delay="0.4s"
                >
                  Compact home printers perfect for daily printing
                </h1>
                <p
                  data-ani="slideinup"
                  data-ani-delay="0.5s"
                  style={{ maxWidth: "550px", color: "white" }}
                >
                  Print assignments, documents, and photos effortlessly with
                  fast setup, affordable printing costs, and easy wireless
                  access from any device.
                </p>
                <div
                  className="btn-group"
                  data-ani="slideinup"
                  data-ani-delay="0.6s"
                >
                  <Link to="/shop" className="th-btn th-icon">
                    Shop Now
                  </Link>
                  <Link to="/contact" className="th-btn style2 th-icon">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>

        {/* ---------- SLIDE 3: LASER PRINTERS ---------- */}
        <SwiperSlide>
          <div className="hero-inner">
            <div
              className="th-hero-bg"
              style={{
                backgroundImage: "url(/assets/img/bg/banner3.jpg)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
              }}
            ></div>
            <div className="container">
              <div className="hero-style1">
                <span
                  className="sub-title style1"
                  data-ani="slideinup"
                  data-ani-delay="0.2s"
                >
                  Smart printing for faster workflow
                </span>
                <h1
                  className="hero-title"
                  data-ani="slideinup"
                  data-ani-delay="0.4s"
                >
                  Precision laser printers made for clearer printing
                </h1>
                <p
                  data-ani="slideinup"
                  data-ani-delay="0.5s"
                  style={{ maxWidth: "550px", color: "white" }}
                >
                  Get professional-grade text, sharp graphics, and long-lasting
                  toner efficiency — perfect for high-volume printing and
                  quality-focused users.
                </p>
                <div
                  className="btn-group"
                  data-ani="slideinup"
                  data-ani-delay="0.6s"
                >
                  <Link to="/shop" className="th-btn th-icon">
                    Shop Now
                  </Link>
                  <Link to="/contact" className="th-btn style2 th-icon">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>

        <div className="th-swiper-custom">
          <button
            className="slider-arrow slider-prev"
            onClick={() => handleSliderNavigation("prev")}
          >
            <img src="/assets/img/icon/right-arrow.svg" alt="Prev" />
          </button>
          <div className="swiper-pagination" />
          <button
            className="slider-arrow slider-next"
            onClick={() => handleSliderNavigation("next")}
          >
            <img src="/assets/img/icon/left-arrow.svg" alt="Next" />
          </button>
        </div>
      </Swiper>
    </div>
  );
}

export default BannerOne;
